/**
 * CreditBalanceCard — kartu saldo point di hub Belanja (plan 19 Fase 1).
 *
 * Presentational murni (tanpa hooks) supaya bisa diuji langsung sebagai
 * fungsi (pola belanja-layout.test.ts). Data di-fetch parent screen.
 */

import { Pressable, StyleSheet, View } from 'react-native';

import { AppIcon } from '@/components/app-icon';
import { ThemedText } from '@/components/themed-text';
import { Brand, Radii, Spacing } from '@/constants/theme';
import { MISC_ICON } from '@/lib/icons';

interface CreditBalanceCardProps {
  /** null saat sedang loading / gagal dimuat. */
  balance: number | null;
  onPressTopUp: () => void;
  onPressHistory: () => void;
}

export function CreditBalanceCard({
  balance,
  onPressTopUp,
  onPressHistory,
}: CreditBalanceCardProps) {
  return (
    <View style={styles.card}>
      <View style={styles.main}>
        <View style={styles.copy}>
          <ThemedText style={styles.label}>Saldo point</ThemedText>
          <ThemedText style={styles.balance}>
            {balance === null ? '…' : balance}
          </ThemedText>
          <ThemedText style={styles.hint}>
            1 point = 1 worksheet
          </ThemedText>
          <View style={styles.actions}>
            <Pressable
              onPress={onPressTopUp}
              style={({ pressed }) => [styles.topUpBtn, pressed && styles.pressed]}
              accessibilityRole="button"
              accessibilityLabel="Top up point"
            >
              <ThemedText style={styles.topUpBtnText}>Top up</ThemedText>
            </Pressable>
            <Pressable
              onPress={onPressHistory}
              style={({ pressed }) => [styles.historyBtn, pressed && styles.pressed]}
              accessibilityRole="button"
              accessibilityLabel="Riwayat transaksi"
            >
              <ThemedText style={styles.historyBtnText}>Riwayat</ThemedText>
            </Pressable>
          </View>
        </View>
        <View style={styles.orb}>
          <AppIcon source={MISC_ICON.cards} size={52} />
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: Brand.primaryDark,
    borderRadius: Radii.medium,
    overflow: 'hidden',
    padding: Spacing.four,
  },
  main: { alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between' },
  // flex:1 + minWidth:0 wajib — copy saldo harus menyempit sebelum orb dekoratif.
  copy: { flex: 1, minWidth: 0, marginRight: Spacing.three },
  label: { color: '#d9cdea', fontSize: 13, fontWeight: '600' },
  balance: { color: '#ffffff', fontSize: 32, fontWeight: '700', lineHeight: 38, marginTop: Spacing.one },
  hint: { color: '#d9cdea', fontSize: 12, lineHeight: 18 },
  actions: { flexDirection: 'row', gap: Spacing.two, marginTop: Spacing.three },
  topUpBtn: {
    backgroundColor: '#f9cf67',
    borderRadius: Radii.pill,
    paddingHorizontal: Spacing.three,
    paddingVertical: Spacing.two,
  },
  topUpBtnText: { color: Brand.primaryDark, fontSize: 13, fontWeight: '700' },
  historyBtn: {
    borderColor: '#d9cdea',
    borderRadius: Radii.pill,
    borderWidth: 1,
    paddingHorizontal: Spacing.three,
    paddingVertical: Spacing.two,
  },
  historyBtnText: { color: '#ffffff', fontSize: 13, fontWeight: '600' },
  pressed: { opacity: 0.75 },
  orb: {
    alignItems: 'center',
    backgroundColor: '#f9cf67',
    borderRadius: 42,
    height: 84,
    justifyContent: 'center',
    transform: [{ rotate: '7deg' }],
    width: 84,
  },
});
